import { useReducerState } from 'sb-hooks'
import { useCallback, useEffect } from 'react'
import gqlRequest from 'sb-request/graphql'
import formatPrice from 'helpers/modifiers/formatPrice'


export const monthlyPlans = {
  MONTHLY_2PCS: {
    discount: '-16%',
  },
  MONTHLY_3PCS: {
    discount: '-22%',
  },
}

export const prepaidPlans = {
  QUARTER: {
    discount: '-3%',
  },
  SEMI_ANNUAL: {
    discount: '-6%',
  },
  ANNUAL: {
    discount: '-10%',
  },
}

const initialState = {
  isFetching: false,
  plans: [],
  selectedPlan: null,
}

const usePlans = ({ plans: basePlans, additionalPlans, sortFunction } = {}) => {
  const [ { isFetching, plans, selectedPlan }, setState ] = useReducerState(initialState)

  let usedPlans = basePlans || monthlyPlans

  if (additionalPlans) {
    usedPlans = {
      ...usedPlans,
      ...additionalPlans,
    }
  }

  const setSelectedPlan = useCallback((selectedPlanName) => {
    setState({ selectedPlan: plans.find(({ name }) => name === selectedPlanName) })
  }, [ setState, plans ])

  useEffect(() => {
    setState({ isFetching: true })

    gqlRequest.post('graphql?name=plans', {
      body: {
        query: `{
          plans {
            name
            save
            selected
            totalPrice
            productCount
            productPrice
            productsPerPeriod
            billingPeriod
          }
        }`,
      },
    })
      .then(({ plans }) => {
        const visibleKeys = Object.keys(usedPlans)
        let visiblePlans = (plans || [])
          .filter(({ name }) => visibleKeys.includes(name))
          .map((plan) => {
            const { save } = plan
            const saveValue = save * 1 !== 0 ? formatPrice(save, false, true) : null

            return {
              ...plan,
              ...usedPlans[plan.name],
              saveValue,
            }
          })

        if (sortFunction) {
          visiblePlans = visiblePlans.sort(sortFunction)
        }

        setState({ plans: visiblePlans, isFetching: false })
      })
      .finally(() => setState({ isFetching: false }))
  }, [])

  return {
    isFetching,
    plans,
    setSelectedPlan,
    selectedPlan,
  }
}


export default usePlans
